<mat-drawer-container class="example-container" autosize>


  <div class="event-container">
    <!-- <div class="top-bar">
      <div class="row align-items-center">
        <div class="col-3 col-sm-3 col-md-3 col-lg-2">
          <a href="#" (click)="goHome()">
            <img class="img-icon-css cursor" src="assets/logo white.png" alt="Logo" />
          </a>
        </div>

        <div class="col-6 col-sm-6 col-md-6 col-lg-8 text-center">
          <span class="app-title">Picaggo</span>
        </div>

        <div class="col-3 col-sm-3 col-md-3 col-lg-2 text-end">
          <mat-icon class="cursor" (click)="drawer.toggle()">menu</mat-icon>
        </div>
      </div>
    </div>  -->


    <ng-template [ngIf]="!isCreating">
      <!-- Event Creation Form -->

      <div class="event-card">
        <div class="create-event-header">
          <div class="back-div">
            <button class="back-btn" type="button" *ngIf="showEventDetail" (click)="showEventDetail = false">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="20" fill="white" />
                <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
                <path d="M28 20H12M12 20L18 14M12 20L18 26" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>

            </button>
          </div>
          <div> <span class="title">Create Event</span>
          </div>

          <div>

            <button *ngIf="!isMobile" class="close-btn" type="button" (click)="close()">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="20" fill="white" />
                <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
                <path d="M15.7578 15.7578L24.2431 24.2431" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M15.7569 24.2431L24.2422 15.7578" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>

            </button>
            <button *ngIf="isMobile" class="close-btn" type="button" (click)="goHome()">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="40" height="40" rx="20" fill="white" />
                <rect x="0.5" y="0.5" width="39" height="39" rx="19.5" stroke="black" stroke-opacity="0.1" />
                <path d="M15.7578 15.7578L24.2431 24.2431" stroke="#131A26" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
                <path d="M15.7569 24.2431L24.2422 15.7578" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>

            </button>
          </div>
        </div>
        <form [formGroup]="newEventForm" class="eventForm" (ngSubmit)="onSubmit()">
          <!-- ** Show Error Message -->
          <div class="alert alert-danger" *ngIf="showMessage != ''">
            {{ showMessage }}
          </div>
          <!-- Scrollable Content -->
          <div class="event-content" *ngIf="!showEventDetail">
            <div class="form-group">
              <label>Event Name</label>
              <input matInput formControlName="eventName" maxlength="200" type="text" placeholder="Enter Event Name"
                required />
              <mat-hint align="end" style="font-size: x-small;color:gray">
                {{ formControls.eventName.value?.length || 0 }}/200 characters
              </mat-hint>
              <div *ngIf="formControls.eventName.touched && formControls.eventName.invalid"
                style="padding: 5px; margin-bottom: 2px;" class="alert alert-danger">
                <p style="margin: 0 !important;" class="error">Event Name is required.</p>
              </div>
              <!-- <mat-hint align="end" style="font-size: x-small;color:gray">{{ formControls.eventName.value?.length || 0 }}/200</mat-hint> -->
              <mat-error *ngIf="isCharLimitExceeded">
                Maximum 200 characters allowed.
              </mat-error>
            </div>

            <div class="form-group">
              <label>Host</label>
              <input matInput class="host-name" maxlength="50" formControlName="hostedBy" type="text"
                placeholder="Add Host Name" />
              <div *ngIf="formControls.hostedBy.touched && formControls.hostedBy.invalid"
                style="padding: 5px; margin-bottom: 2px;" class="alert alert-danger">
                <p style="margin: 0 !important;" class="error">Host Name is required.</p>
              </div>
            </div>
            <!-- Form Fields -->
            <div class="form-group">
              <label>Event Category</label>
              <div class="category-pills">
                <button type="button" class="category-pill"
                  *ngFor="let pill of categoryPills"
                  [class.selected]="isPillSelected(pill)"
                  (click)="selectCategoryPill(pill)">
                  {{ pill }}
                </button>
              </div>

              <!-- Custom name input, shown only when "Other" is selected -->
              <div *ngIf="showOtherCategoryInput" style="margin-top: 10px;">
                <div class="custom-input-wrapper">
                  <input type="text" maxlength="50" matInput formControlName="eventCategory"
                    placeholder="Enter category name" class="custom-input" />
                </div>
                <div class="char-count-hint">
                  {{ formControls.eventCategory.value?.length || 0 }}/50 characters
                </div>
              </div>

              <div *ngIf="formControls.eventCategory.touched && formControls.eventCategory.invalid
                " style="padding: 5px; margin-bottom: 2px" class="alert alert-danger">
                <p style="margin: 0 !important" class="error">
                  Category Selection is required.
                </p>
              </div>
              <mat-error
                *ngIf="formControls.eventCategory.hasError('maxlength') && (formControls.eventCategory.touched || formControls.eventCategory.dirty)">
                Maximum 50 characters allowed.
              </mat-error>
            </div>
            <div class="header-2">Event timings</div>

            <!-- <div class="datetime-container">
              <label class="datetime-label">Start</label>
              
              <div class="datetime-display">
                <span class="date-text" (click)="openDatePicker = !openDatePicker">
                  {{ selectedDate | date: 'dd MMMM yyyy' }}
                </span>
                ,
                <span class="time-text" (click)="openTimeDropdown = !openTimeDropdown">
                  {{ selectedTime }}
                </span>
              </div>
            
               <mat-calendar *ngIf="openDatePicker" [(selected)]="selectedDate" (selectedChange)="onDateChange($event)" class="custom-calendar"></mat-calendar>
            
              <div *ngIf="openTimeDropdown" class="time-dropdown">
                <div class="time-option" *ngFor="let time of timeOptions" (click)="selectTime(time)">
                  {{ time }}
                </div>
              </div>
            </div>  -->

            <!-- <div class="form-group">
              <label>Start</label>
              <div class="date-time">

                <input matInput [ngxMatDatetimePicker]="startTime" required formControlName="startTime"
                  (dateChange)="onStartTimeChange($event)">
                <mat-datepicker-toggle matSuffix [for]="$any(startTime)"></mat-datepicker-toggle>
                <ngx-mat-datetime-picker #startTime [showSpinners]="showSpinners" [showSeconds]="showSeconds"
                  [stepHour]="stepHour" [stepMinute]="stepMinute" [touchUi]="touchUi" [enableMeridian]="enableMeridian">
                  <ng-template ngxMatDatetimePickerActions style="position: relative;width: auto;">
                    <button style="position: relative;width: auto;" mat-button
                      (click)="startTime.close()">Close</button>
                  </ng-template>
                </ngx-mat-datetime-picker>
                <div *ngIf="newEventForm.controls['startTime'].hasError('pastDate')" class="alert alert-danger">
                  <p class="error">Start time cannot be in the past.</p>
                </div>
              
              </div>

            </div> -->


            <!-- <div class="form-group">
              <label>Timezone</label>
              <div class="custom-input-wrapper" style="margin-bottom: 8px;">
                <input type="text" [(ngModel)]="timezoneSearchText" (ngModelChange)="filterTimezones($event)"
                  [ngModelOptions]="{standalone: true}" placeholder="Search timezone..." class="custom-input">
                <svg class="input-icon" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <circle cx="8" cy="8" r="6" stroke="#666" stroke-width="1.5" />
                  <path d="M12.5 12.5L16 16" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </div>
              <div class="custom-select-wrapper">
                <select formControlName="timezone" (change)="onTimezoneChange()" class="custom-select">
                  <option *ngFor="let tz of filteredTimezones" [value]="tz.value">
                    {{ tz.label }}
                  </option>
                </select>
                <svg class="select-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
              </div>
            </div> -->


            <div class="form-group">
              <label for="startDate" style="padding-bottom: 10px;">Start</label>
              <div class="date-time-grid">
                <!-- Date Input -->
                <div class="custom-input-wrapper">
                  <input type="date" formControlName="startTime" (change)="onStartDateChange()" class="custom-input"
                    required placeholder="Select date">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.667 1.667v2.5M13.333 1.667v2.5M2.917 7.5h14.166M4.167 3.333h11.666c.92 0 1.667.746 1.667 1.667v11.667c0 .92-.746 1.666-1.667 1.666H4.167c-.92 0-1.667-.746-1.667-1.666V5c0-.92.746-1.667 1.667-1.667z"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>

                <!-- Time Dropdown -->
                <div class="custom-select-wrapper">
                  <select formControlName="startTimeString" (change)="onStartTimeChange()" class="custom-select">
                    <option value="" disabled selected>Select time</option>
                    <option *ngFor="let time of timeOptions" [value]="time">{{ time }}</option>
                  </select>
                  <svg class="select-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
              </div>

              <!-- Validation Error -->
              <div *ngIf="newEventForm.controls['startTime'].hasError('pastDate')" class="error-message">
                Start time cannot be in the past.
              </div>

              <!-- Start Now Checkbox -->
              <label class="checkbox-inline flex items-center gap-2">
                <input type="checkbox" [(ngModel)]="useNow" [ngModelOptions]="{ standalone: true }"
                  (change)="toggleNowCheckbox()">
                <span>Start now</span>
              </label>
            </div>

            <div class="form-group">
              <label for="endDate" style="padding-bottom: 10px;">End</label>
              <div class="date-time-grid">
                <!-- Date Input -->
                <div class="custom-input-wrapper">
                  <input type="date" formControlName="endTime" (change)="onEndDateChange()" class="custom-input"
                    required placeholder="Select date">
                  <svg class="input-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M6.667 1.667v2.5M13.333 1.667v2.5M2.917 7.5h14.166M4.167 3.333h11.666c.92 0 1.667.746 1.667 1.667v11.667c0 .92-.746 1.666-1.667 1.666H4.167c-.92 0-1.667-.746-1.667-1.666V5c0-.92.746-1.667 1.667-1.667z"
                      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </div>

                <!-- Time Dropdown -->
                <div class="custom-select-wrapper">
                  <select formControlName="endTimeString" (change)="onEndTimeChange()" class="custom-select">
                    <option value="" disabled selected>Select time</option>
                    <option *ngFor="let time of timeOptions" [value]="time">{{ time }}</option>
                  </select>
                  <svg class="select-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round" />
                  </svg>
                </div>
              </div>

              <!-- Validation Errors -->
              <div *ngIf="newEventForm.errors?.['endBeforeStart']" class="error-message">
                End Time must be after Start Time.
              </div>
              <div *ngIf="newEventForm.errors?.['durationExceedsLimit']" class="error-message">
                Event duration cannot exceed 10 days.
              </div>
            </div>
            <div class="event-duration">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21 13C21 17.9706 16.9706 22 12 22C7.02944 22 3 17.9706 3 13C3 8.02944 7.02944 4 12 4C16.9706 4 21 8.02944 21 13Z"
                  stroke="currentColor" stroke-width="1.5" />
                <path d="M12 13V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M10 2H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              </svg>
              <div class="event-duration-text">
                Event set for {{ eventDuration }}</div>
            </div>
              <!-- Storage Upgrade Banner -->
            <app-storage-upgrade-banner style="display:block;padding:8px 0 0;margin-bottom: 24px;"></app-storage-upgrade-banner>
            <div style="float: left;font-size: 12px;color:gray;margin-left: 10px;
          margin-top: 15px;">Step 1/2</div>
            <!-- Show this to continue to next section -->
            <button type="button" class="submit-btn" (click)="goToSection2()">
              Next
            </button>
          
             
          </div>
      
          <!-- Second Section -->
          <div *ngIf="showEventDetail">
            <div class="event-header">

              <div *ngIf="coverImage == null" class="image-container">
                <!-- <img src="/assets/icon/imageplaceholder.png" class="profile-image"
                      alt="Navbar Background Image" /> -->
                <button type="button" (click)="changeCover()" class="edit-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M21.9998 12.6978C21.9983 14.1674 21.9871 15.4165 21.9036 16.4414C21.8067 17.6308 21.6081 18.6246 21.1636 19.45C20.9676 19.814 20.7267 20.1401 20.4334 20.4334C19.601 21.2657 18.5405 21.6428 17.1966 21.8235C15.8835 22 14.2007 22 12.0534 22H11.9466C9.79929 22 8.11646 22 6.80345 21.8235C5.45951 21.6428 4.39902 21.2657 3.56664 20.4334C2.82871 19.6954 2.44763 18.777 2.24498 17.6376C2.04591 16.5184 2.00949 15.1259 2.00192 13.3967C2 12.9569 2 12.4917 2 12.0009V11.9466C1.99999 9.79929 1.99998 8.11646 2.17651 6.80345C2.3572 5.45951 2.73426 4.39902 3.56664 3.56664C4.39902 2.73426 5.45951 2.3572 6.80345 2.17651C7.97111 2.01952 9.47346 2.00215 11.302 2.00024C11.6873 1.99983 12 2.31236 12 2.69767C12 3.08299 11.6872 3.3952 11.3019 3.39561C9.44749 3.39757 8.06751 3.41446 6.98937 3.55941C5.80016 3.7193 5.08321 4.02339 4.5533 4.5533C4.02339 5.08321 3.7193 5.80016 3.55941 6.98937C3.39683 8.19866 3.39535 9.7877 3.39535 12C3.39535 12.2702 3.39535 12.5314 3.39567 12.7844L4.32696 11.9696C5.17465 11.2278 6.45225 11.2704 7.24872 12.0668L11.2392 16.0573C11.8785 16.6966 12.8848 16.7837 13.6245 16.2639L13.9019 16.0689C14.9663 15.3209 16.4064 15.4076 17.3734 16.2779L20.0064 18.6476C20.2714 18.091 20.4288 17.3597 20.5128 16.3281C20.592 15.3561 20.6029 14.1755 20.6044 12.6979C20.6048 12.3126 20.917 12 21.3023 12C21.6876 12 22.0002 12.3125 21.9998 12.6978Z"
                      fill="currentColor" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M17.5 11C15.3787 11 14.318 11 13.659 10.341C13 9.68198 13 8.62132 13 6.5C13 4.37868 13 3.31802 13.659 2.65901C14.318 2 15.3787 2 17.5 2C19.6213 2 20.682 2 21.341 2.65901C22 3.31802 22 4.37868 22 6.5C22 8.62132 22 9.68198 21.341 10.341C20.682 11 19.6213 11 17.5 11ZM18.25 4.5C18.25 4.08579 17.9142 3.75 17.5 3.75C17.0858 3.75 16.75 4.08579 16.75 4.5V5.75H15.5C15.0858 5.75 14.75 6.08579 14.75 6.5C14.75 6.91421 15.0858 7.25 15.5 7.25H16.75V8.5C16.75 8.91421 17.0858 9.25 17.5 9.25C17.9142 9.25 18.25 8.91421 18.25 8.5V7.25H19.5C19.9142 7.25 20.25 6.91421 20.25 6.5C20.25 6.08579 19.9142 5.75 19.5 5.75H18.25V4.5Z"
                      fill="currentColor" />
                  </svg>
                  Add Cover Image
                </button>
              </div>
              <div class="image-container2" *ngIf="coverImage != null">
                <img [src]="coverImage" class="imgPlaceholder" alt="Navbar Background Image" />
                <button type="button" (click)="changeCover()" class="edit-icon2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M21.9998 12.6978C21.9983 14.1674 21.9871 15.4165 21.9036 16.4414C21.8067 17.6308 21.6081 18.6246 21.1636 19.45C20.9676 19.814 20.7267 20.1401 20.4334 20.4334C19.601 21.2657 18.5405 21.6428 17.1966 21.8235C15.8835 22 14.2007 22 12.0534 22H11.9466C9.79929 22 8.11646 22 6.80345 21.8235C5.45951 21.6428 4.39902 21.2657 3.56664 20.4334C2.82871 19.6954 2.44763 18.777 2.24498 17.6376C2.04591 16.5184 2.00949 15.1259 2.00192 13.3967C2 12.9569 2 12.4917 2 12.0009V11.9466C1.99999 9.79929 1.99998 8.11646 2.17651 6.80345C2.3572 5.45951 2.73426 4.39902 3.56664 3.56664C4.39902 2.73426 5.45951 2.3572 6.80345 2.17651C7.97111 2.01952 9.47346 2.00215 11.302 2.00024C11.6873 1.99983 12 2.31236 12 2.69767C12 3.08299 11.6872 3.3952 11.3019 3.39561C9.44749 3.39757 8.06751 3.41446 6.98937 3.55941C5.80016 3.7193 5.08321 4.02339 4.5533 4.5533C4.02339 5.08321 3.7193 5.80016 3.55941 6.98937C3.39683 8.19866 3.39535 9.7877 3.39535 12C3.39535 12.2702 3.39535 12.5314 3.39567 12.7844L4.32696 11.9696C5.17465 11.2278 6.45225 11.2704 7.24872 12.0668L11.2392 16.0573C11.8785 16.6966 12.8848 16.7837 13.6245 16.2639L13.9019 16.0689C14.9663 15.3209 16.4064 15.4076 17.3734 16.2779L20.0064 18.6476C20.2714 18.091 20.4288 17.3597 20.5128 16.3281C20.592 15.3561 20.6029 14.1755 20.6044 12.6979C20.6048 12.3126 20.917 12 21.3023 12C21.6876 12 22.0002 12.3125 21.9998 12.6978Z"
                      fill="currentColor" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M17.5 11C15.3787 11 14.318 11 13.659 10.341C13 9.68198 13 8.62132 13 6.5C13 4.37868 13 3.31802 13.659 2.65901C14.318 2 15.3787 2 17.5 2C19.6213 2 20.682 2 21.341 2.65901C22 3.31802 22 4.37868 22 6.5C22 8.62132 22 9.68198 21.341 10.341C20.682 11 19.6213 11 17.5 11ZM18.25 4.5C18.25 4.08579 17.9142 3.75 17.5 3.75C17.0858 3.75 16.75 4.08579 16.75 4.5V5.75H15.5C15.0858 5.75 14.75 6.08579 14.75 6.5C14.75 6.91421 15.0858 7.25 15.5 7.25H16.75V8.5C16.75 8.91421 17.0858 9.25 17.5 9.25C17.9142 9.25 18.25 8.91421 18.25 8.5V7.25H19.5C19.9142 7.25 20.25 6.91421 20.25 6.5C20.25 6.08579 19.9142 5.75 19.5 5.75H18.25V4.5Z"
                      fill="currentColor" />
                  </svg>
                  Change Cover Image
                </button>
              </div>
              <!-- Crop Cover Image -->

              <!-- Image cropper -->
              <div *ngIf="showCropper" class="cropper-container">
                <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                  [aspectRatio]="2.7 / 1" [resizeToWidth]="820" format="jpeg" (imageCropped)="imageCropped($event)"
                  (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
                  (loadImageFailed)="loadImageFailed()"></image-cropper>
              </div>

              <!-- Preview of cropped image -->
              <div *ngIf="croppedImage" class="preview-container">
                <h3>Preview</h3>
                <img [src]="croppedImage" alt="Cropped Image" class="preview-image" />
              </div>
              <!-- Button to trigger cover image update -->
              <!-- <button (click)="showCropper = !showCropper">Update Cover Image</button>

              <app-cover-image-crop *ngIf="showCropper"></app-cover-image-crop> -->
            </div>
            <div class="invitation-header" *ngIf="isFutureEvent">Invitation</div>
            <div class="textarea-container" *ngIf="isFutureEvent">
              <div class="label-row">
                <label for="invitationMessage">Invitation Message</label>
                <button class="ai-button" type="button" (click)="generateMessage()"><svg width="20" height="20"
                    viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.33333 5.83333L7.90333 6.995C7.34 8.51833 7.05833 9.28 6.5025 9.83583C5.94667 10.3917 5.185 10.6733 3.66167 11.2367L2.5 11.6667L3.66167 12.0967C5.185 12.66 5.94667 12.9425 6.5025 13.4975C7.05833 14.0525 7.34 14.815 7.90333 16.3383L8.33333 17.5L8.76333 16.3383C9.32667 14.815 9.60917 14.0533 10.1642 13.4975C10.7192 12.9417 11.4817 12.66 13.005 12.0967L14.1667 11.6667L13.005 11.2367C11.4817 10.6733 10.72 10.3917 10.1642 9.83583C9.60833 9.28 9.32667 8.51833 8.76333 6.995L8.33333 5.83333ZM15 2.5L14.8158 2.9975C14.5742 3.65083 14.4533 3.9775 14.2158 4.215C13.9775 4.45333 13.6508 4.57417 12.9975 4.815L12.5 5L12.9983 5.18417C13.6508 5.42583 13.9775 5.54667 14.215 5.78417C14.4533 6.0225 14.5742 6.34917 14.815 7.0025L15 7.5L15.1842 7.0025C15.4258 6.34917 15.5467 6.0225 15.7842 5.785C16.0225 5.54667 16.3492 5.42583 17.0025 5.185L17.5 5L17.0017 4.81583C16.3492 4.57417 16.0225 4.45333 15.785 4.21583C15.5467 3.9775 15.4258 3.65083 15.185 2.9975L15 2.5Z"
                      stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  Generate with AI</button>
              </div>
              <textarea matInput id="invitationMessage" rows="4" formControlName="message" maxlength="300"
                placeholder="Enter Invite Message..."></textarea>
              <div class="char-count">{{ newEventForm.value.message?.length }}/300 Characters</div>
            </div>
            <div class="overlay1" *ngIf="isGenerating">
              <span class="loader"></span>
            </div>
            <!-- <div class="form-group">
              <label>Invitation Message</label>
              <button style="margin-top: 5px;" mat-raised-button (click)="generateMessage()">✨ Generate with AI</button>
              <textarea matInput formControlName="message" rows="4" placeholder="Enter Invite Message..."></textarea>
            </div> -->
            <!-- <div class="form-group" *ngIf="isFutureEvent">
              <div class="switch">
                <span class="rsvp-label" style="float: left;
                font-family: 'Manrope';
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: normal;">Collect RSVP</span>
                <mat-slide-toggle labelPosition="before" formControlName="rsvp" style="float: right;"
                  class="slide-toggle"></mat-slide-toggle>
                <span style="font-size: 12px;color: gray;padding-top: 8px;float: left;"> <svg width="24" height="24"
                    viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" />
                    <path d="M12 17V11" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" />
                    <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="currentColor" fill-opacity="0.5" />
                  </svg>
                  Turning on RSVP will ask guests if they’re attending and how many will join.</span>
              </div>
            </div>
            <div class="form-group" *ngIf="isFutureEvent">
              <label>Location</label>
              <input matInput formControlName="eventLocation" type="text" placeholder="Enter Location Here">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectLocation($event)">
                <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion.description">
                  {{ suggestion.description }}
                </mat-option>
              </mat-autocomplete>
              <mat-error
                *ngIf="newEventForm.get('eventLocation')?.hasError('required') && newEventForm.get('eventLocation')?.touched">
                Location is required when RSVP is collected.
              </mat-error>
            </div> -->
            <div class="folders-container">
              <div class="folders-header">
                <h2 class="invitation-header">Albums</h2>
                <button mat-button class="add-folder-btn" (click)="openFolderDialog($event)">
                  <span class="plus-icon">+</span> Add album
                </button>
              </div>
              <span style="font-size: 13px;color: gray;padding-top: 8px;"> <svg width="24" height="24"
                  viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" />
                  <path d="M12 17V11" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" />
                  <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="currentColor" fill-opacity="0.5" />
                </svg>
                Create albums to organize photos, videos, and memories within your event.</span>
              <!-- <div class="folders-list">
                <div class="folder-card" *ngFor="let folder of subfolders; let i = index">
                  <div class="folder-title">{{folder}} </div>
                  <button class="folder-close-btn" (click)="removeFolder(i)">×</button>
                </div>
              </div> -->
              <div class="folders-list">
                <div class="folder-item" *ngFor="let folder of subfolders; let i = index">
                  <div class="folder-name">{{ folder }}</div>
                  <div class="folder-actions">
                    <button class="icon-btn" (click)="removeFolder(i)">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.5001 6H3.5" stroke="#131A26" stroke-width="1.5" stroke-linecap="round" />
                        <path
                          d="M18.8332 8.5L18.3732 15.3991C18.1962 18.054 18.1077 19.3815 17.2427 20.1907C16.3777 21 15.0473 21 12.3865 21H11.6132C8.95235 21 7.62195 21 6.75694 20.1907C5.89194 19.3815 5.80344 18.054 5.62644 15.3991L5.1665 8.5"
                          stroke="#131A26" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M9.5 11L10 16" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" />
                        <path d="M14.5 11L14 16" stroke="#1C274C" stroke-width="1.5" stroke-linecap="round" />
                        <path
                          d="M6.5 6C6.55588 6 6.58382 6 6.60915 5.99936C7.43259 5.97849 8.15902 5.45491 8.43922 4.68032C8.44784 4.65649 8.45667 4.62999 8.47434 4.57697L8.57143 4.28571C8.65431 4.03708 8.69575 3.91276 8.75071 3.8072C8.97001 3.38607 9.37574 3.09364 9.84461 3.01877C9.96213 3 10.0932 3 10.3553 3H13.6447C13.9068 3 14.0379 3 14.1554 3.01877C14.6243 3.09364 15.03 3.38607 15.2493 3.8072C15.3043 3.91276 15.3457 4.03708 15.4286 4.28571L15.5257 4.57697C15.5433 4.62992 15.5522 4.65651 15.5608 4.68032C15.841 5.45491 16.5674 5.97849 17.3909 5.99936C17.4162 6 17.4441 6 17.5 6"
                          stroke="#1C274C" stroke-width="1.5" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
             <!-- Storage Upgrade Banner -->
            <app-storage-upgrade-banner style="display:block;padding:8px 0 0;margin-bottom: 24px;"></app-storage-upgrade-banner>
            <div style="margin-bottom: 16px;">
              <div style="float: left;font-size: 12px;color:gray;margin-left: 10px;margin-top: 15px;">Step 2/2</div>
              <button class="submit-btn">Create Event</button>
              <button class="submit-btn prev-btn"
                style="width: 100px;border:1px solid lightgray;margin-right: 5px;"
                (click)="showEventDetail = false">Previous</button>
            </div>
          
          </div>
        </form>
  
        <app-confirmation-modal *ngIf="showConfirmModal" [confirmMessage]="confirmMessage" [isHomePage]="false"
          (confirmed)="onChangeConfirmed($event)"></app-confirmation-modal>
        <!-- Popup Modal -->
        <div class="popup-overlay" *ngIf="isFolderDialogOpen">
          <div class="popup">
            <h2 style="float: left;position: relative;
            left: 21%;">Add New Album</h2>
            <p class="limit-warning" *ngIf="subfolders.length >= 10">
              Maximum 10 albums allowed.
            </p>
            <button style="float: right;position: relative;top:-7px;right: -5px;" class="btn"
              (click)="closeFolderDialog()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.0008 13.3998L7.10078 18.2998C6.91745 18.4831 6.68411 18.5748 6.40078 18.5748C6.11745 18.5748 5.88411 18.4831 5.70078 18.2998C5.51745 18.1165 5.42578 17.8831 5.42578 17.5998C5.42578 17.3165 5.51745 17.0831 5.70078 16.8998L10.6008 11.9998L5.70078 7.0998C5.51745 6.91647 5.42578 6.68314 5.42578 6.3998C5.42578 6.11647 5.51745 5.88314 5.70078 5.6998C5.88411 5.51647 6.11745 5.4248 6.40078 5.4248C6.68411 5.4248 6.91745 5.51647 7.10078 5.6998L12.0008 10.5998L16.9008 5.6998C17.0841 5.51647 17.3174 5.4248 17.6008 5.4248C17.8841 5.4248 18.1174 5.51647 18.3008 5.6998C18.4841 5.88314 18.5758 6.11647 18.5758 6.3998C18.5758 6.68314 18.4841 6.91647 18.3008 7.0998L13.4008 11.9998L18.3008 16.8998C18.4841 17.0831 18.5758 17.3165 18.5758 17.5998C18.5758 17.8831 18.4841 18.1165 18.3008 18.2998C18.1174 18.4831 17.8841 18.5748 17.6008 18.5748C17.3174 18.5748 17.0841 18.4831 16.9008 18.2998L12.0008 13.3998Z"
                  fill="currentColor" />
              </svg></button>
            <input [disabled]="subfolders.length >= 10" [(ngModel)]="newFolderName" placeholder="Enter Album Name"
              class="input-field" />
            <div class="popup-actions">

              <button (click)="addFolder($event)" class="save-btn">Save</button>
            </div>
          </div>
        </div>

        <div class="popup-overlay" *ngIf="showSuccessPopup">

          <div class="popup-card">
            <button mat-button mat-dialog-close (click)="closeSuccessPopup()" style="float: right">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.0008 13.3998L7.10078 18.2998C6.91745 18.4831 6.68411 18.5748 6.40078 18.5748C6.11745 18.5748 5.88411 18.4831 5.70078 18.2998C5.51745 18.1165 5.42578 17.8831 5.42578 17.5998C5.42578 17.3165 5.51745 17.0831 5.70078 16.8998L10.6008 11.9998L5.70078 7.0998C5.51745 6.91647 5.42578 6.68314 5.42578 6.3998C5.42578 6.11647 5.51745 5.88314 5.70078 5.6998C5.88411 5.51647 6.11745 5.4248 6.40078 5.4248C6.68411 5.4248 6.91745 5.51647 7.10078 5.6998L12.0008 10.5998L16.9008 5.6998C17.0841 5.51647 17.3174 5.4248 17.6008 5.4248C17.8841 5.4248 18.1174 5.51647 18.3008 5.6998C18.4841 5.88314 18.5758 6.11647 18.5758 6.3998C18.5758 6.68314 18.4841 6.91647 18.3008 7.0998L13.4008 11.9998L18.3008 16.8998C18.4841 17.0831 18.5758 17.3165 18.5758 17.5998C18.5758 17.8831 18.4841 18.1165 18.3008 18.2998C18.1174 18.4831 17.8841 18.5748 17.6008 18.5748C17.3174 18.5748 17.0841 18.4831 16.9008 18.2998L12.0008 13.3998Z"
                  fill="currentColor" />
              </svg>
            </button>
            <div class="popup-icon">
              <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" width="96" height="96" rx="48" fill="#F5F5F7" />
                <path
                  d="M50.5778 60.7728L51.1115 60.5949C55.7075 59.0629 58.0056 58.2969 58.4335 56.4844C58.8613 54.6718 57.1485 52.959 53.7228 49.5333L50.3442 46.1547C50.3412 46.1642 50.3381 46.1741 50.3348 46.1843C50.2956 46.3079 50.2388 46.49 50.1703 46.7188C50.0331 47.1771 49.8501 47.819 49.6674 48.5506C49.2934 50.0483 48.9539 51.7945 48.9539 53.1104C48.9539 54.4263 49.2934 56.1725 49.6674 57.6701C49.8501 58.4018 50.0331 59.0436 50.1703 59.5019C50.2388 59.7307 50.2956 59.9128 50.3348 60.0364C50.3544 60.0982 50.3696 60.1453 50.3797 60.1763L50.3908 60.2103L50.3933 60.2179L50.5778 60.7728Z"
                  fill="#1C274C" />
                <path
                  d="M39.443 64.4826C34.9199 65.9738 32.5368 66.5979 31.2185 65.2796C29.7587 63.8198 30.6805 61.0544 32.5241 55.5236L35.9031 45.3866C37.1672 41.5945 37.9097 39.3668 39.1488 38.4631L39.1384 38.5147C39.124 38.5865 39.1031 38.6915 39.0768 38.8265C39.0243 39.0965 38.9501 39.4869 38.8624 39.9732C38.6873 40.9453 38.4579 42.3037 38.2407 43.8515C37.8104 46.9179 37.4119 50.8359 37.6172 53.9667C37.7414 55.8612 38.1356 58.2113 38.4873 60.0477C38.6649 60.9745 38.8348 61.7867 38.9605 62.3676C39.0233 62.6583 39.0752 62.8915 39.1115 63.0527L39.1538 63.239L39.443 64.4826Z"
                  fill="#1C274C" />
                <path
                  d="M42.2007 38.5179L42.0993 39.0085L42.0983 39.0133L42.0947 39.0312L42.0797 39.1055C42.0664 39.1717 42.0467 39.2708 42.0216 39.3996C41.9714 39.6573 41.8998 40.034 41.8149 40.5053C41.6449 41.4485 41.4222 42.7675 41.2116 44.2683C40.7863 47.299 40.4267 50.9628 40.6108 53.7704C40.7222 55.4702 41.0863 57.6692 41.4338 59.4833C41.6059 60.3817 41.7708 61.1701 41.8927 61.7334C41.9535 62.0149 42.0036 62.2398 42.0382 62.3935L42.078 62.569L42.0882 62.6132L42.3018 63.5315L47.7317 61.7215L47.5268 61.104C47.5146 61.0667 47.4972 61.0128 47.4754 60.9439C47.4317 60.8063 47.37 60.6084 47.2963 60.3623C47.1492 59.8708 46.9532 59.1833 46.7568 58.397C46.3726 56.8586 45.9539 54.814 45.9539 53.1104C45.9539 51.4068 46.3726 49.3622 46.7568 47.8238C46.9532 47.0374 47.1492 46.35 47.2963 45.8585C47.37 45.6124 47.4317 45.4145 47.4754 45.2768C47.4972 45.208 47.5146 45.1541 47.5268 45.1167L47.545 45.0611L47.9705 43.781L46.9648 42.7753C44.8775 40.688 43.4262 39.2367 42.2007 38.5179Z"
                  fill="#1C274C" />
                <path
                  d="M46.3529 28.7204C47.0597 29.1525 47.2824 30.0758 46.8503 30.7826C46.5367 31.2955 46.6153 31.9564 47.0404 32.3815L47.2361 32.5773C48.4135 33.7546 48.8476 35.4841 48.3658 37.0779C48.1261 37.8709 47.289 38.3194 46.496 38.0797C45.703 37.84 45.2545 37.0028 45.4942 36.2098C45.6559 35.6747 45.5101 35.0939 45.1148 34.6986L44.9191 34.5028C43.514 33.0978 43.2543 30.9132 44.2907 29.2178C44.7228 28.511 45.646 28.2883 46.3529 28.7204Z"
                  fill="#EE4147" />
                <path
                  d="M51.6221 32.7932C52.0242 32.3911 52.2252 32.19 52.4577 32.1163C52.6543 32.054 52.8654 32.054 53.0621 32.1163C53.2945 32.19 53.4956 32.3911 53.8977 32.7932C54.2998 33.1953 54.5009 33.3963 54.5746 33.6288C54.6369 33.8254 54.6369 34.0365 54.5746 34.2332C54.5009 34.4657 54.2998 34.6667 53.8977 35.0688C53.4956 35.4709 53.2945 35.672 53.0621 35.7457C52.8654 35.808 52.6543 35.808 52.4577 35.7457C52.2252 35.672 52.0242 35.4709 51.6221 35.0688C51.2199 34.6667 51.0189 34.4657 50.9452 34.2332C50.8829 34.0365 50.8829 33.8254 50.9452 33.6288C51.0189 33.3963 51.2199 33.1953 51.6221 32.7932Z"
                  fill="#EE4147" />
                <path
                  d="M38.3542 31.8818C38.7732 31.4629 39.4524 31.4629 39.8713 31.8818C40.2903 32.3007 40.2903 32.98 39.8713 33.3989C39.4524 33.8178 38.7732 33.8178 38.3542 33.3989C37.9353 32.98 37.9353 32.3007 38.3542 31.8818Z"
                  fill="#EE4147" />
                <path
                  d="M64.4494 38.0936C64.1726 38.2003 63.9272 38.4457 63.4364 38.9364C62.9457 39.4272 62.7003 39.6726 62.5936 39.9494C62.4688 40.2734 62.4688 40.6322 62.5936 40.9561C62.7003 41.233 62.9457 41.4784 63.4364 41.9691C63.9272 42.4599 64.1726 42.7053 64.4494 42.812C64.7734 42.9368 65.1322 42.9368 65.4561 42.812C65.733 42.7053 65.9784 42.4599 66.4691 41.9691C66.9599 41.4784 67.2053 41.233 67.312 40.9561C67.4368 40.6322 67.4368 40.2734 67.312 39.9494C67.2053 39.6726 66.9599 39.4272 66.4691 38.9364C65.9784 38.4457 65.733 38.2003 65.4561 38.0936C65.1322 37.9688 64.7734 37.9688 64.4494 38.0936Z"
                  fill="#EE4147" />
                <path
                  d="M62.616 54.6267C63.0349 54.2078 63.7141 54.2078 64.1331 54.6267C64.552 55.0456 64.552 55.7249 64.1331 56.1438C63.7141 56.5627 63.0349 56.5627 62.616 56.1438C62.197 55.7249 62.197 55.0456 62.616 54.6267Z"
                  fill="#EE4147" />
                <path
                  d="M59.8784 33.4435C60.6908 33.6059 61.2176 34.3962 61.0551 35.2085L60.7671 36.6484C60.3708 38.63 58.9431 40.2474 57.0259 40.8864C56.13 41.185 55.4629 41.9408 55.2777 42.8667L54.9897 44.3066C54.8272 45.119 54.037 45.6458 53.2247 45.4833C52.4123 45.3208 51.8855 44.5306 52.048 43.7183L52.3359 42.2784C52.7323 40.2968 54.16 38.6794 56.0772 38.0404C56.973 37.7418 57.6402 36.986 57.8254 36.06L58.1134 34.6202C58.2758 33.8078 59.0661 33.281 59.8784 33.4435Z"
                  fill="#EE4147" />
                <path
                  d="M67.3164 49.1192C66.5929 48.8029 65.7516 48.9358 65.1609 49.4596C63.5424 50.8948 61.1871 51.1334 59.3137 50.0518L58.888 49.806C58.1705 49.3918 57.9247 48.4744 58.3389 47.757C58.7532 47.0395 59.6705 46.7937 60.388 47.2079L60.8137 47.4537C61.5688 47.8896 62.5181 47.7935 63.1705 47.215C64.6361 45.9153 66.7234 45.5857 68.5182 46.3705L69.1012 46.6254C69.8602 46.9573 70.2065 47.8416 69.8746 48.6007C69.5427 49.3597 68.6584 49.706 67.8993 49.3741L67.3164 49.1192Z"
                  fill="#EE4147" />
                <path
                  d="M59.5003 43.4832C59.9192 43.0642 60.5985 43.0642 61.0174 43.4832C61.4363 43.9021 61.4363 44.5814 61.0174 45.0003C60.5985 45.4192 59.9192 45.4192 59.5003 45.0003C59.0814 44.5814 59.0814 43.9021 59.5003 43.4832Z"
                  fill="#EE4147" />
              </svg>

            </div>
            <div class="popup-message">
              You have successfully created<br />an Event!
            </div>
          </div>
        </div>
      </div>
     
    </ng-template>

    <ng-template [ngIf]="isCreating">
      <div class="overlay" *ngIf="!isMobile">
        <span class="loader"></span>
      </div>
      <div class="overlay1" *ngIf="isMobile">
        <span class="loader"></span>
      </div>
    </ng-template>
    <!-- <ng-template [ngIf]="isCreating">
      <div style="height: 90vh">
        
        <div class="ring">
          <svg width="76" height="31" viewBox="0 0 96 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M63.7782 2.95119H76.0185V0.975586H63.7782V2.95119ZM18.6251 10.6671C18.6251 9.75786 19.3622 9.02077 20.2715 9.02077H72.7718C73.6811 9.02077 74.4182 9.75786 74.4182 10.6671V32.884C74.4182 33.7932 73.6811 34.5303 72.7718 34.5303H56.6308C59.9348 32.223 62.099 28.3725 62.099 24.0121C62.099 16.9518 56.425 11.2283 49.4257 11.2283C48.5014 11.2283 47.6001 11.3282 46.732 11.5177H27.2898C25.313 11.5177 23.7251 13.1318 23.7251 15.1049V37.3913C23.7251 39.3643 25.313 40.9784 27.2898 40.9784H96V39.0028H27.2898C26.4202 39.0028 25.7007 38.2894 25.7007 37.3913V15.1049C25.7007 14.2067 26.4202 13.4933 27.2898 13.4933H42.2215C38.9171 15.8005 36.7525 19.6513 36.7525 24.0121C36.7525 31.0724 42.4265 36.7959 49.4257 36.7959C50.3511 36.7959 51.2534 36.6959 52.1224 36.5059H72.7718C74.7722 36.5059 76.3938 34.8843 76.3938 32.884V10.6671C76.3938 8.66676 74.7722 7.04517 72.7718 7.04517H20.2715C18.2711 7.04517 16.6495 8.66677 16.6495 10.6671V28.6144C16.6495 29.5237 15.9124 30.2608 15.0032 30.2608H0V32.2364H15.0032C17.0035 32.2364 18.6251 30.6148 18.6251 28.6144V10.6671ZM60.1234 24.0121C60.1234 29.9975 55.3178 34.8203 49.4257 34.8203C43.5337 34.8203 38.7281 29.9975 38.7281 24.0121C38.7281 18.0267 43.5337 13.2039 49.4257 13.2039C55.3178 13.2039 60.1234 18.0267 60.1234 24.0121Z"
              fill="white" />
          </svg>
          <span class="loader"></span>
        </div>
      </div>
    </ng-template> -->
  </div>
</mat-drawer-container>